import { useState } from "react";
import TextBox from "../../forms/inputs/TextBox";
import { IconType } from "react-icons";
import VisibilityIcon from "./VisiblityIcon";

const AuthTextBox = ({
  label,
  name,
  placeholder,
  rules,
  password,
  Icon,
  className
}: React.ComponentProps<typeof TextBox> & {
  label: string;
  Icon: IconType;
}) => {
  const [focused, setFocus] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={className + " w-full"}>
      <label className="mb-2 block text-sm font-medium text-gray-700">
        {label} <span className="text-red-600">*</span>
      </label>

      <div
        className={`relative flex w-full items-center gap-3 rounded-md border bg-white px-4 py-3.5 transition-colors ${
          focused
            ? "border-blue-500 ring-2 ring-blue-500 ring-opacity-20"
            : "border-gray-300 hover:border-gray-400"
        }`}
      >
        <Icon
          className={`h-5 w-5 ${
            focused ? "text-blue-600" : "text-gray-400"
          }`}
        />

        <TextBox
          name={name}
          placeholder={placeholder}
          password={password && !showPassword}
          rules={rules}
          className="w-full text-sm text-gray-900 placeholder-gray-400 focus:outline-none"
          errorClassName="placeholder:text-red-500"
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />

        {password && (
          <VisibilityIcon
            visible={showPassword}
            onClick={() => setShowPassword(!showPassword)}
          />
        )}
      </div>
    </div>
  );
};

export default AuthTextBox;
